import { factoryWithDefaultOptions } from '@/lib/logger/utils'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export const createStructuredLoggerFromConsole = factoryWithDefaultOptions<Console>(
  { version: undefined, region: undefined },
  (logger, options) => ({
    trace: (log, message) => {
      logger.log({ ...log, message, version: options.version, region: options.region })
    },
    debug: (log, message) => {
      logger.log({ ...log, message, version: options.version, region: options.region })
    },
    info: (log, message) => {
      logger.log({ ...log, message, version: options.version, region: options.region })
    },
    warn: (log, message) => {
      logger.log({ ...log, message, version: options.version, region: options.region })
    },
    error: (log, message) => {
      logger.log({ ...log, message, version: options.version, region: options.region })
    },
    fatal: (log, message) => {
      logger.log({ ...log, message, version: options.version, region: options.region })
    },
    logAxiosError: () => undefined,
    logUnexpectedError: () => undefined,
    warnUnexpectedError: () => undefined,
    traceFunction: (fn) => fn,
    traceAsyncFunction: (fn) => fn,
    initAxiosTrace: (fn) => fn,
  })
)

export const createStructuredLoggerFromAppInsights = factoryWithDefaultOptions<ApplicationInsights>(
  { version: undefined, region: undefined },
  (logger, options) => ({
    trace: (log, message) => {
      logger.trackEvent(
        { name: 'client-trace' },
        { ...log, message, version: options.version, region: options.region }
      )
    },
    debug: (log, message) => {
      logger.trackEvent(
        { name: 'client-debug' },
        { ...log, message, version: options.version, region: options.region }
      )
    },
    info: (log, message) => {
      logger.trackEvent(
        { name: 'client-info' },
        { ...log, message, version: options.version, region: options.region }
      )
    },
    warn: (log, message) => {
      logger.trackEvent(
        { name: 'client-warn' },
        { ...log, message, version: options.version, region: options.region }
      )
    },
    error: (log, message) => {
      logger.trackEvent(
        { name: 'client-error' },
        { ...log, message, version: options.version, region: options.region }
      )
    },
    fatal: (log, message) => {
      logger.trackEvent(
        { name: 'client-fatal' },
        { ...log, message, version: options.version, region: options.region }
      )
    },
    logAxiosError: () => undefined,
    logUnexpectedError: () => undefined,
    warnUnexpectedError: () => undefined,
    traceFunction: (fn) => fn,
    traceAsyncFunction: (fn) => fn,
    initAxiosTrace: (fn) => fn,
  })
)
